var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-w-screen sm:tw-w-100 tw-px-2"},[_c('div',{staticClass:" tw-w-full tw-h-auto tw-bg-white tw-z-10 tw-rounded-large tw-pb-14 tw-px-6 tw-pt-8 tw-border tw-border-solid tw-border-black-50"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }